import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ActionButton } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 55 * 60 + 25);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
}
export function Pricing({
  showAnchor = false
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-brand-dark" data-id="element-95">
      <div className="bg-[#1c0909] px-4 py-16 sm:py-20" data-id="element-96">
        <div className="mx-auto max-w-4xl text-center" data-id="element-97">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-98">
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" data-id="element-99">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-100">
                <div data-id="element-101">
                  <p className="font-display text-5xl font-bold text-red-500 sm:text-7xl" data-id="element-102">
                    {value}
                  </p>
                  <p className="text-xs tracking-[.2em] text-slate-400" data-id="element-103">
                    {label}
                  </p>
                </div>
                {index < 2 && <span className="pt-2 font-display text-4xl text-red-500 sm:text-6xl" data-id="element-104">
                    :
                  </span>}
              </Fragment>)}
          </div>
          <p className="mt-6 text-slate-400" data-id="element-105">
            Después sube. <b className="text-white" data-id="element-106">No vuelve.</b>
          </p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-red-500/20 bg-brand-ink p-4 text-left" data-id="element-107">
            <div className="flex justify-between text-sm font-medium text-red-400" data-id="element-108">
              <span data-id="element-109">Cupos al precio de lanzamiento</span>
              <span data-id="element-110">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-slate-800" data-id="element-111">
              <div className="h-full w-[68%] rounded-full bg-red-500" data-id="element-112" />
            </div>
            <p className="mt-2 text-right text-xs text-slate-500" data-id="element-113">
              68% de los cupos ya tomados
            </p>
          </div>
        </div>
      </div>

      <div className="px-4 py-16 sm:py-24" data-id="element-114">
        <div className="mx-auto max-w-2xl" data-id="element-115">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-116">
            TU SISTEMA COMPLETO
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-8 rounded-3xl border-2 border-brand-green bg-brand-ink p-6 shadow-[0_0_30px_rgba(22,163,74,.13)] sm:p-9" data-id="element-117">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-118">
              <div data-id="element-119">
                <h3 className="font-display text-lg font-bold text-brand-light" data-id="element-120">
                  PROTOCOLO — PARKINSON BAJO CONTROL™
                </h3>
                <p className="mt-1 text-sm text-slate-400" data-id="element-121">
                  5 Volúmenes + 5 Bonos · Acceso inmediato
                </p>
                <p className="mt-3 text-sm text-brand-light" data-id="element-122">
                  Tu protocolo completo en PDF + 5 bonos estratégicos de regalo.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-123">
                <p className="text-slate-500 line-through" data-id="element-124">$65.000</p>
                <p className="font-display text-4xl font-bold text-brand-light" data-id="element-125">
                  $19.990
                </p>
                <p className="text-xs text-slate-400" data-id="element-126">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton className="mt-7" showTrust data-id="element-127">
            QUIERO MI SISTEMA AHORA
          </ActionButton>
        </div>
      </div>
    </section>;
}